module.exports = __webpack_public_path__ + "img/Costa-Rica.e02405aa.png";